import Logo from "./Logo";
import SocialMedia from "./SocialMedia";
import ConnectWallet from "./ConnectWallet";

export default function NavBar({ paired, hashconnect,toggleHamburguerMenu  }) {
  return (
    <nav className="bg-darker h-[40px] lg:h-[70px] flex justify-evenly items-center relative z-[9998]">
      <SocialMedia  toggleHamburguerMenu ={toggleHamburguerMenu }/>
      <Logo />
      <ConnectWallet paired={paired} hashconnect={hashconnect} />
    </nav>
  );
}